var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"selectLang",attrs:{"label":"Language","items":_vm.names,"item-value":"value","item-text":"name","return-object":"","solo":"","dense":"","background-color":"blue darken-4","prepend-inner-icon":"language"},on:{"change":_vm.setLocale},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.text)+" ")]}},{key:"item",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.text)+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }